import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
})
export class TruncateTextPipe implements PipeTransform {
  transform(text: string, searchedText: string): string {
    if (!text || !text.trim() || !searchedText || !searchedText.trim()) return text;

    let truncated = '';
    const maximumChars = 200;
    const leftChars = 100;
    const rightChars = 100;
    const dots = '...';
    const firstWordIndex = text.toLowerCase().indexOf(searchedText.toLowerCase());

    if (firstWordIndex === 0) {
      return text.substring(0, maximumChars);
    }

    const start = Math.max(0, firstWordIndex - leftChars);
    const end = Math.min(text.length, firstWordIndex + searchedText.length + rightChars);
    truncated = text.substring(start, end);

    if (start > 0) truncated = dots + truncated;

    if (end < text.length) truncated = truncated + dots;

    return truncated;
  }
}
